/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function desktopFiltersDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            'facets': '=',
            'isFilterDropdownOpen': '=',
            'activeCategory': '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: desktopFilters,
        template: require('./fullPageFiltersView.html')
    };
}

desktopFilters.$inject = [
    'FiltersService',
    'CmsContentService'
];
function desktopFilters(
    FiltersService,
    CmsContentService
) {

    this.$onInit = () => {
        const vm = this;

        CmsContentService.retrieveCMSContent('filters');

        vm.closeFilterDropdown = function () {
            vm.isFilterDropdownOpen = false;
            $('body').removeClass('full-screen-open');
            $('#call-to-action').addClass('open');
            $('.comparison-tray').addClass('open');
        };

        vm.filterResults = filterResults;

        vm.resetFilters = resetFilters;

        vm.getFilterInputType = FiltersService.getFilterInputType;
        vm.isCheckboxFilter = FiltersService.isCheckboxFilter;

        vm.isEnabled = !FiltersService.isNewFiltersEnabled;

        /**
         * Filters the resulting products for this category.
         *
         * @param {Boolean} [topFiltersChanged=false]
         */
        function filterResults(topFiltersChanged) {
            vm.closeFilterDropdown();
            FiltersService.filterResults(topFiltersChanged);
        }
    };

    /**
     * Resets all filters
     *
     */
    function resetFilters() {
        FiltersService.resetFilters();
    }

}

module.exports = desktopFiltersDirective;
